// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';

// import useGetTransactionTypesList from '@hooks/INV/TransactionTypes/useGetTransactionTypesList';
// import Loading from '@components/Shared/Loader/Loading';
// import { Link, useParams } from 'react-router-dom';
// import AddReason from './AddReason';
// import useGetTypeReasonsByTransactionTypeId from '@hooks/INV/TransactionTypes/useGetTypeReasonsByTransactionTypeId';
// import ModalComponent from '@components/Modal/ModalComponent';
// import { type TypeReasonsModels } from '@store/INV/TransactionTypes/TransactionTypesModels';
// import UpdateReason from './UpdateReason';
// import NtxTable from '@components/DataTable/NtxTable';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';
// // import Reasons from './Reasons';

// // MIR : "fc437ea7-caf1-46ad-85b3-9dea0c5accdb" صرف
// // MII : "24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad" اضافة

// const TypeReasons = () => {
//   const { HasPermission } = usePermissions();

//   const { transactionType } = useParams();
//   const [details, setDetails] = useState<TypeReasonsModels>();

//   const { t, i18n } = useTranslation();
//   const { TransactionTypesList, loading, error } = useGetTransactionTypesList();
//   const transaction = TransactionTypesList.find(f => f.id === transactionType);
//   const { TypeReasonsByTransactionTypeId: data } = useGetTypeReasonsByTransactionTypeId(transactionType);

//   const columns = [
//     { title: t('Name'), key: 'Name' },
//     { title: t('Description'), key: 'Description' },
//     { title: t('Type'), key: 'Type' },
//     { title: t('Account'), key: 'Account' },
//     { title: t(''), key: 'action', className: 'text-end', sortable: false }
//   ];

//   const tableData = data?.map((item: any) => {
//     let rowClass;

//     return {
//       Name: i18n.language === 'ar' ? item.name2 : item.name,
//       Description: i18n.language === 'en' ? item.description : item.description2,
//       Type: i18n.language === 'en' ? item.transactionTypeName : item.transactionTypeName2,
//       Account: i18n.language === 'en' ? item.accountName : item.accountName2,
//       action: (
//         <>
//           <button
//             hidden={!HasPermission('INVEditTransactionTypeReasons')}
//             type='button'
//             className='btn btn-outline-theme'
//             data-bs-toggle='modal'
//             data-bs-target='#UpdateReasons'
//             onClick={() => setDetails(item)}
//           >
//             <i className='far fa-lg me-2 fa-fw fa-edit'></i>
//             {t('Button.Edit')}
//           </button>
//         </>
//       )
//     };
//   });

//   //________________________________
//   const BcrumbList = [
//     {
//       name: 'Home',
//      link: ':moduleHome'
//     },
//     {
//       name: 'TransactionTypes',
//       link: '/INV/InventorySettings/TransactionTypes'
//     },
//     {
//       name: transaction?.code === 'MII' ? 'أسباب الصرف' : 'أسباب الإضافة',
//       link: null
//     }
//   ];
//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={BcrumbList}
//           PageName={transaction?.code === 'MII' ? 'أسباب الصرف' : 'أسباب الإضافة'}
//         />
//         <div className='ms-auto'>
//           {}
//           <Link
//             hidden={!HasPermission('INVAddTransactionTypeReasons')}
//             to=''
//             className='btn me-1 btn-theme'
//             data-bs-toggle='modal'
//             data-bs-target='#AddReasons'
//           >
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('NewReason')}
//           </Link>
//         </div>
//       </div>

//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <ModalComponent id='AddReasons' title={t('NewReason')} size='lg'>
//         <AddReason type={transactionType === '24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad' ? 'Issue' : 'receive'} />
//       </ModalComponent>

//       <ModalComponent id='UpdateReasons' title={t('UpdateReasons')} size='lg'>
//         {details && <UpdateReason data={details} />}
//       </ModalComponent>
//     </>
//   );
// };

// export default TypeReasons;



import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';

import useGetTransactionTypesList from '@hooks/INV/TransactionTypes/useGetTransactionTypesList';
import Loading from '@components/Shared/Loader/Loading';
import { Link, useParams } from 'react-router-dom';
import AddReason from './AddReason';
import useGetTypeReasonsByTransactionTypeId from '@hooks/INV/TransactionTypes/useGetTypeReasonsByTransactionTypeId';
import ModalComponent from '@components/Modal/ModalComponent';
import { type TypeReasonsModels } from '@store/INV/TransactionTypes/TransactionTypesModels';
import UpdateReason from './UpdateReason';
import NtxTable from '@components/DataTable/NtxTable';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const TypeReasons = () => {
  const { HasPermission } = usePermissions();

  const { transactionType } = useParams();
  const [details, setDetails] = useState<TypeReasonsModels>();

  const { t, i18n } = useTranslation();
  const { TransactionTypesList, loading, error } = useGetTransactionTypesList();
  const transaction = TransactionTypesList.find(f => f.id === transactionType);
  const { TypeReasonsByTransactionTypeId: data } = useGetTypeReasonsByTransactionTypeId(transactionType);

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Type'), key: 'Type' },
    { title: t('Account'), key: 'Account' },
    { title: t('Description'), key: 'Description' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.map((item: any) => {
    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Description: i18n.language === 'en' ? item.description : item.description2,
      Type: i18n.language === 'en' ? item.transactionTypeName : item.transactionTypeName2,
      Account: i18n.language === 'en' ? item.accountName : item.accountName2,
      action: (
        <>
          <button
            hidden={!HasPermission('INVEditTransactionTypeReasons')}
            type='button'
            className='btn btn-outline-theme'
            data-bs-toggle='modal'
            data-bs-target='#UpdateReasons'
            onClick={() => setDetails(item)}
          >
            <i className='far fa-lg me-2 fa-fw fa-edit'></i>
            {t('Edit')}
          </button>
        </>
      )
    };
  });

  const BcrumbList = [
    {
      name: t('Home'),
     link: ':moduleHome'
    },
    {
      name: t('TransactionTypes'),
      link: '/INV/InventorySettings/TransactionTypes'
    },
    {
      name: transaction?.code === 'MII' ? t('IssuanceReasons') : t('AdditionReasons'),
      link: null
    }
  ];
  
  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={BcrumbList}
          PageName={transaction?.code === 'MII' ? t('IssuanceReasons') : t('AdditionReasons')}
        />
        <div className='ms-auto'>
          <Link
            hidden={!HasPermission('INVAddTransactionTypeReasons')}
            to=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#AddReasons'
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewReason')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id='AddReasons' title={t('NewReason')} size='lg'>
        <AddReason type={transactionType === '24e295ae-15d7-4f85-ad43-e7cfa4f8e9ad' ? 'Issue' : 'receive'} />
      </ModalComponent>

      <ModalComponent id='UpdateReasons' title={t('UpdateReason')} size='lg'>
        {details && <UpdateReason data={details} />}
      </ModalComponent>
    </>
  );
};

export default TypeReasons;